import JSONApiClient from '../jsonapi-service';
import { authService } from '../auth-service';
import AxiosService from '../axios-service';
import _ from 'lodash';

export function createDeliverable(deliverableData) {

  const client = JSONApiClient();

  const deliverable = client.create('deliverables');

  deliverable.set('title', deliverableData.title);
  deliverable.set('channelType', deliverableData.channelType);
  deliverable.set('assetType', deliverableData.assetType);
  deliverable.set('dueDate', deliverableData.dueDate);
  if (deliverableData.liveDateStart) { deliverable.set('liveDateStart', deliverableData.liveDateStart); }
  deliverable.set('liveDateEnd', deliverableData.liveDateEnd);
  deliverable.set('live', false);
  if (deliverableData.description) { deliverable.set('description', deliverableData.description); }
  deliverable.set('discussion', { type: 'discussions', id: deliverableData.discussionId });

  return deliverable.sync()
    .then(response => {
      // Returns a resource not a JSON object
      return response;
    });
}

// Updates main deliverable data created when assigning a deliverable
export function updateDeliverableInfo(deliverableId, deliverableData) {

  const client = JSONApiClient();

  return client.get('deliverables', deliverableId, {})
    .then(deliverable => {
      deliverable.set('title', deliverableData.title);
      deliverable.set('channelType', deliverableData.channelType);
      deliverable.set('assetType', deliverableData.assetType);
      deliverable.set('dueDate', deliverableData.dueDate);
      deliverable.set('liveDateEnd', deliverableData.liveDateEnd);
      if (deliverableData.description) deliverable.set('description', deliverableData.description);
      return deliverable.sync();
    });
}

export function updateDeliverableIsLive(deliverableId, deliverableData) {

  const client = JSONApiClient();

  return client.get('deliverables', deliverableId, {})
    .then(deliverable => {
      deliverable.set('live', deliverableData.live);
      return deliverable.sync();
    });
}

// Updates document, comments and version data used when adding deliverables
export function updateDeliverableData(deliverableId, data) {

  const { document, comments, version } = data;

  const client = JSONApiClient();

  return client.get('deliverables', deliverableId, {})
    .then(deliverable => {
      if (document) {
        deliverable.relationships('documents').add(document);
        deliverable.set('version', version);
      }
      if (comments && comments.length > 0) {
        _.forEach(comments, (comment => deliverable.relationships('comments').add(comment)));
      }
      return deliverable.sync();
    });
}

export function updateDeliverableComments(deliverableId, commentData) {

  const client = JSONApiClient();

  return client.get('deliverables', deliverableId, {})
    .then(deliverable => {
      deliverable.relationships('comments').add(commentData);
      return deliverable.sync();
    });
}

function makeDeliverableQuery(deliverableId) {
  const query = `
  query Deliverables {
    deliverables(id: "${deliverableId}") {
      id
      title
      channelType
      assetType
      dueDate
      liveDateStart
      liveDateEnd
      live
      description
      createdBy
      createdDate
      document {
        id
        name
        docType
        fileType
        size
        discussion {
          id
        }
        filePath
        message
        createdBy
        createdDate
        approved
        approvalDate
        approvedBy
        version
      }
      documents {
        id
        name
        docType
        fileType
        size
        discussion {
          id
        }
        filePath
        message
        createdBy
        createdDate
        approved
        approvalDate
        approvedBy
        version
      }
      version
      discussion {
        id
        name
        channelURL
        campaign {
          id
          name
        }
      }
      comments {
        id
        comment
        commentType
        deliverable {
          id
        }
        document {
          id
          name
        }
        user {
          id
          name
        }
        createdBy
        createdDate
      }
    }
  }
  `;
  return query;
}

export function getDeliverable(deliverableId) {

  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}`, });

  const query = makeDeliverableQuery(deliverableId);

  return axiosService.post('', {
    query: query,
    variables: null,
    operationName: null
  })
  .then(response => {
    return response.data.data.deliverables[0];
  });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/deliverables.js
 **/